import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CardGridView from '../components/CardGridView';  // Assuming the CardGridView component is in the same directory
import SERVICES_DATA from '../data/ServiceData';  // Import the services data
import '../css/services.css';  // Assuming you have a services.css file for styling
import '../styles/services.scss';  // Assuming you have a services.scss file for styling

const Services = () => {
  return (
    <Container className='services-container' >
      <h1 className="services-title mt-2">Our Services</h1>
      <p className="">
        At FarmHouse Media and Consulting, we provide a wide range of web development and consulting services tailored to meet the needs of
        small businesses in Eastern North Carolina. Our services are designed to help you establish a strong online presence and grow your business through effective, customized solutions.
      </p>
      <div className='text-center'>
       <Link to="/portfolio" className="portfolio-button">
  Check out our Work
</Link>
      </div>

      <div className="services-wrapper text-center">
        <div className="card-grid-container">
          <CardGridView data={SERVICES_DATA} />
        </div>
      </div>
    </Container>

  );
};

export default Services;

// <Container>
//   <Row>
//     <Col>
//       <h1 className="text-start mt-2">Our Services</h1>
//       <p>
//         At FarmHouse Media and Consulting, we provide a wide range of web development and consulting services tailored to meet the needs of small businesses in Eastern North Carolina. Our services are designed to help you establish a strong online presence and grow your business through effective, customized solutions.
//       </p>
//       <h3>Web Development and Design</h3>
//       <p>
//         We specialize in creating visually stunning, responsive websites that are optimized for both desktop and mobile devices, ensuring a seamless user experience across all platforms.
//       </p>

//       <h3>Web Services and Automations</h3>
//       <p>
//         We offer scalable web services and automated solutions to streamline your business processes and enhance operational efficiency, saving you time and resources.
//       </p>

//       <h3>E-Commerce Solutions</h3>
//       <p>
//         Build secure and reliable e-commerce platforms with integrated payment gateways and inventory management systems that enable smooth online transactions.
//       </p>

//       <h3>Social Media & Digital Marketing</h3>
//       <p>
//         We help you grow your online presence by creating and managing targeted social media campaigns, SEO strategies, and online advertising to increase engagement and drive traffic.
//       </p>

//       <h3>Cloud Hosting Solutions and Services</h3>
//       <p>
//         Our cloud hosting solutions provide fast, reliable, and scalable hosting options for your website or application, ensuring maximum uptime and security.
//       </p>

//       <h3>Business Analytics, Reporting, and Consulting</h3>
//       <p>
//         Leverage our business analytics and consulting services to gain actionable insights, make informed decisions, and boost your growth through data-driven strategies.
//       </p>
//     </Col>
//   </Row>
// </Container>
